/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The CompleteInfoForm model module.
   * @module token/model/CompleteInfoForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CompleteInfoForm</code>.
   * @alias module:token/model/CompleteInfoForm
   * @class
   * @param code {String} 钉钉授权登录code
   * @param app {String} 泛美教育：EDU，收费统计，FEE
   * @param name {String} 姓名
   * @param idNumber {String} 身份证号，若返回为空，则跳转到完善个人信息页面
   */
  var exports = function(code, app, name, idNumber) {
    var _this = this;

    _this['code'] = code;
    _this['app'] = app;
    _this['name'] = name;
    _this['idNumber'] = idNumber;
  };

  /**
   * Constructs a <code>CompleteInfoForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/CompleteInfoForm} obj Optional instance to populate.
   * @return {module:token/model/CompleteInfoForm} The populated <code>CompleteInfoForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'app')) {
        obj['app'] = ApiClient.convertToType(data['app'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
    }
    return obj;
  }

  /**
   * 钉钉授权登录code
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 泛美教育：EDU，收费统计，FEE
   * @member {String} app
   */
  exports.prototype['app'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 身份证号，若返回为空，则跳转到完善个人信息页面
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;



  export default exports;
;


